var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spl-deadline-list-header"},[_c('form-button',{on:{"onClick":_vm.handleCreateDeadline}},[_vm._v(" Create Deadline ")]),_c('form-button',{staticStyle:{"grid-column":"3"},attrs:{"data-cy":"deadline-detail-header-excel"},on:{"onClick":_vm.handleDownload}},[_vm._v(" Excel ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }